import React, { useState, useMemo } from "react";
import Select from "react-select";
import Lesson from "./LessonManager";
import Meditation from "./MeditationManager";
import Movement from "./MovementManager";
import Visualization from "./VisualizationManager";
import Course from "./CourseManager";
import Challenge from "./ChallengeManager";
import Habit from "./HabitManager";
import Resource from "./ResourceManager";
import Notification from "./NotificationManager";
import SignUp from "./SignUpManager";
import withSession from "./withSession";

import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";

const ContentManager = (props) => {
  // Memoize default option and options array
  const defaultOption = useMemo(
    () => ({ value: "challenge", label: "Challenge" }),
    []
  );
  const options = useMemo(
    () => [
      {
        value: "challenge",
        label: "Challenge",
        access: ["feelwise", "regulate", "lumify", "yas"],
      },
      {
        value: "course",
        label: "Course",
        access: ["feelwise", "regulate", "lumify", "yas", "mendedLight"],
      },
      {
        value: "habit",
        label: "Habit",
        access: ["feelwise", "regulate", "lumify", "yas"],
      },
      { value: "lesson", label: "Lesson" },
      {
        value: "meditation",
        label: "Meditation",
        access: ["feelwise", "regulate", "lumify", "yas"],
      },
      {
        value: "movement",
        label: "Movement",
        access: ["feelwise", "regulate", "lumify", "yas"],
      },
      {
        value: "notification",
        label: "Notification",
        access: ["feelwise", "regulate", "lumify", "yas"],
      },
      {
        value: "resource",
        label: "Resource",
        access: ["feelwise", "regulate", "lumify", "yas"],
      },
      {
        value: "signup",
        label: "Sign Up",
        access: ["feelwise", "regulate", "lumify", "yas"],
      },
      {
        value: "visualization",
        label: "Visualization",
        access: ["feelwise", "regulate", "lumify", "yas"],
      },
    ],
    []
  );

  // State to track the selected option, initialized to the Lesson option
  const [selectedOption, setSelectedOption] = useState(defaultOption);

  // Function to handle selection changes
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  // Function to render the appropriate component based on selection
  const renderContent = () => {
    switch (selectedOption?.value) {
      case "challenge":
        return <Challenge />;
      case "course":
        return <Course />;
      case "habit":
        return <Habit />;
      case "lesson":
        return <Lesson />;
      case "meditation":
        return <Meditation />;
      case "movement":
        return <Movement />;
      case "notification":
        return <Notification />;
      case "resource":
        return <Resource />;
      case "signup":
        return <SignUp />;
      case "visualization":
        return <Visualization />;
      default:
        return <Lesson />;
    }
  };

  return (
    <div>
      <h3 className="title">Content Page</h3>
      <Select
        className="react-select info"
        classNamePrefix="react-select"
        placeholder="Choose Content"
        name="contentDropdown"
        closeMenuOnSelect={true}
        value={
          options.find((option) => option.value === selectedOption?.value) ||
          defaultOption
        }
        onChange={handleChange}
        options={filter(options, (option) => {
          return (
            isEmpty(option.access) ||
            includes(option.access, props.session.me.clientName)
          );
        })}
      />
      {renderContent()}
    </div>
  );
};

export default withSession(ContentManager);
